export function PortalTabs({ tabs, activeTab, setActiveTab }) {
  return (
    <div className="flex gap-1 border-b border-gray-200 pb-0">
      {tabs.map(tab => (
        <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors ${activeTab === tab.id ? 'border-[#84CC16] text-[#0A1628] bg-gray-50' : 'border-transparent text-gray-500 hover:text-gray-700'}`}>
          <tab.icon className="w-4 h-4" />
          {tab.label}
        </button>
      ))}
    </div>
  );
}
